import { trackReviewDetails } from "./trackReviewDetails";
import { trackViewPayment } from "./trackViewPayment";

export const checkoutServices = {
  trackReviewDetails,
  trackViewPayment,
};
